/*
 * "If the user asks the agent to update an element that's on the page, we should
 * have a way of refreshing the now modified case."
 *
 * The refresh itself is wired up (see `refreshAdviceCase` and the LoadingOverlay
 * in Advice.js): re-fetch the case and the account breakdown behind the same
 * spinner the make-changes drawer shows on close, so the step re-renders against
 * the agent's edit.
 *
 * OPEN QUESTION (Brecken): nothing in the streamed response tells us a turn
 * mutated the case. Streamed frames carry `statusUpdate: { type, update }` and
 * the persisted message carries `toolName`, so naming the mutating tools here is
 * all it takes to switch this on. It is empty on purpose — matching against the
 * user-facing status copy instead ("Updating your retirement age…") would refresh
 * on any turn that merely talks about a change, and a stray refresh mid-step is
 * worse than a missing one, since the FE has no other way to reconcile.
 */
export const CASE_MUTATING_TOOLS = []

const matches = name => !!name && CASE_MUTATING_TOOLS.includes(name)

/**
 * Whether a finished assistant turn changed the user's case, i.e. the step needs
 * re-fetching. Reads both the tool that produced the message and every status
 * update seen while it streamed.
 */
export const turnModifiedCase = message => {
  if (!message) return false
  if (matches(message.toolName)) return true
  return (message.statusUpdates ?? []).some(status => matches(status?.type))
}

export default turnModifiedCase
